export default {
  getPageTitleList: (t) => {
    return {
      "/dashboard": {
        title: t("__dashboard"),
      },
      "/dashboard/self-service": {
        title: t("__dashboard"),
      },
      "/contact": {
        title: t("__contact_title"),
      },
      "/adpro-suggestions": {
        title: t("__adpro_suggestion"),
      },
      "/account-performance": {
        title: t("__account_performance"),
      },
      "/account-performance/self-service": {
        title: t("__account_performance"),
      },
      "/search-campaigns": {
        title: t("__search_campaign"),
      },
      "/display-campaigns": {
        title: t("__display_campaign"),
      },
      "/payment": {
        title: t("__payment"),
      },
      "/setting": {
        title: t("__settings"),
      },
      "/dashboard/fb": {
        title: t("__dashboard"),
      },
      "/account-performance/fb": {
        title: t("__account_performance"),
      },
      "/rmp-conversions": {
        title: t("__rmp_conversions"),
        subTitle: t("__conversion_header"),
      },
      "/rmp-conversions/fb/r-widget": {
        title: t("__fb_conversions_r_widget"),
        subTitle: t("__conversion_header"),
      },
      "/rmp-conversions/fb/r-crm": {
        title: t("__fb_conversions_r_crm"),
        subTitle: t("__conversion_header"),
      },
      "/rmp-conversions/fb/google-sheets": {
        title: t("__fb_conversions_google_sheets"),
        subTitle: t("__conversion_header"),
      },
      "/rmp-conversions/r-widget": {
        title: t("__r_widget_conversions"),
        subTitle: t("__conversion_header"),
      },
      "/rmp-conversions/r-crm": {
        title: t("__r_crm_conversions"),
        subTitle: t("__conversion_header"),
      },
      "/rmp-conversions/google-sheets": {
        title: t("__google_sheets_conversions"),
        subTitle: t("__conversion_header"),
      },
    };
  },
};
